import { ActionButtonVariants } from 'components/action-button';

export default {
  textTransform: Styles.textTransform.headlines,
  delivery: {
    icon: 'delivery',
    height: '1.75rem',
    width: '1.75rem',
  },
  pickup: {
    icon: 'restaurant',
    height: '1.75rem',
    width: '1.75rem',
  },
  catering: {
    delivery: {
      icon: 'delivery',
      height: '1.75rem',
      width: '1.75rem',
    },
    pickup: {
      icon: 'catering',
      height: '2.15rem',
      width: '2.55rem',
    },
  },
  iconContainer: {
    color: 'white',
  },
  text: {
    color: Styles.color.white,
  },
  bottomServiceWrapper: {
    color: Styles.color.white,
  },
  underline: {
    color: Styles.color.white,
  },
  buttonIcon: 'cart',
  defaultButtonColor: 'primary',
  defaultButtonVariant: ActionButtonVariants.INVERSE,
  inProgressVariant: ActionButtonVariants.OUTLINE,
} as const;
